import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    actions: 'Actions',
    cardActions: {
      lockOrDeleteTitle: 'Lock or delete card',
    },
    cvv: 'CVV: ',
    deactivationTitle: 'Deactivation date',
    deliveryAddress: 'Delivery address',
    description: 'Add an automatic deactivation date to this virtual card.',
    descriptionWithDate:
      'This virtual card will be automatically deactivated on {0}',
    expiryDate: 'Exp: ',
    fakeCard: {
      description1:
        'Your virtual card will be available within 48 hours. You will be notified when it is available.',
      description2:
        'Your virtual card will allow you to start using your account while you wait for your physical card to be delivered.',
      title: 'Card pending creation',
    },
    limits: 'Limits',
    options: 'Options',
    shippingDateTitle: 'Shipping date',
    shippingNotAvailable: 'Your card will be sent to you soon.',
    temporaryCardCta: 'Edit or delete',
    trackingInformation: 'Tracking information',
    trackingNumber: 'La Poste tracking number',
  },
  fr: {
    actions: 'Actions',
    cardActions: {
      lockOrDeleteTitle: 'Bloquer ou supprimer cette carte',
    },
    cvv: 'CVV : ',
    deactivationTitle: 'Date de désactivation',
    deliveryAddress: 'Adresse de livraison',
    description:
      'Ajouter une date de désactivation automatique à cette carte virtuelle.',
    descriptionWithDate: 'Cette carte sera automatiquement désactivée le {0}',
    expiryDate: 'Exp : ',
    fakeCard: {
      description1: `Votre carte virtuelle sera disponible d'ici 48h. Vous serez notifié lorsqu'elle sera disponible.`,
      description2:
        'Votre carte virtuelle vous permettra de commencer à utiliser votre compte en attendant la livraison de votre carte physique.',
      title: 'Carte en cours de création',
    },
    limits: 'Plafonds',
    options: 'Options',
    shippingDateTitle: `Date d'expédition`,
    shippingNotAvailable: 'Votre carte vous sera envoyée bientôt.',
    temporaryCardCta: 'Modifier ou supprimer',
    trackingInformation: 'Informations de suivi',
    trackingNumber: 'Numéro de suivi La Poste',
  },
} as const);

export default locales;
